import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { supabase } from '../../../config/supabase';

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        // Check if there's a custom redirect URL
        const redirectTo = searchParams.get('redirect_to');
        
        if (redirectTo) {
          // Decode and redirect to the custom URL
          const decodedRedirect = decodeURIComponent(redirectTo);
          console.log('Redirecting to custom URL:', decodedRedirect);
          window.location.href = decodedRedirect;
          return;
        }
        
        // Default redirect to dashboard
        return navigate('/dashboard');
        
      } else if (event === 'SIGNED_IN' && !session) {
        // Ocurrió un error durante el inicio de sesión o la sesión no se pudo establecer
        console.error('Error during sign in or session not established.');
        setError('Hubo un problema al iniciar sesión. Por favor, inténtalo de nuevo.');
        setLoading(false);
      }
      // Otros eventos como 'SIGNED_OUT', 'USER_UPDATED' pueden ser manejados aquí si es necesario
    });

    // También puedes verificar la sesión actual inmediatamente por si el evento ya ocurrió
    // o si el usuario ya estaba logueado y llegó aquí por alguna razón.
    const checkSession = async () => {
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      
      if (sessionError) {
        console.error('Error getting session:', sessionError);
        setError('Error al verificar la sesión.');
        setLoading(false);
        return;
      }
      
      // Si ya hay una sesión, manejar el redirect
      if (session) {
        const redirectTo = searchParams.get('redirect_to');
        
        if (redirectTo) {
          const decodedRedirect = decodeURIComponent(redirectTo);
          console.log('Session exists, redirecting to custom URL:', decodedRedirect);
          window.location.href = decodedRedirect;
          return;
        }
        
        navigate('/dashboard');
      }
      // No establecemos setLoading(false) aquí inmediatamente si no hay sesión,
      // ya que onAuthStateChange podría estar procesando.
    };

    checkSession();

    // Limpia la suscripción cuando el componente se desmonte
    return () => {
      subscription?.unsubscribe();
    };
  }, [navigate, searchParams]);

  if (loading && !error) {
    return <div>Procesando autenticación...</div>; // O un componente de carga más elaborado
  }

  if (error) {
    return (
      <div>
        <h1>Error de Autenticación</h1>
        <p>{error}</p>
        <button onClick={() => navigate('/login')}>Volver al Login</button>
      </div>
    );
  }

  // Si no está cargando y no hay error, debería haber sido redirigido.
  // Puedes poner un fallback por si acaso.
  return <div>Redirigiendo...</div>;
};

export default AuthCallbackPage;